import { useEffect } from 'react';
import { TasksStore } from 'src/stores/TasksStore/TasksStore';
import { TaskWithActionStore } from 'src/stores/TaskWithActionStore/TaskWithActionStore';

export const useAssignedTasksInterval = () => {
    useEffect(() => {
        const interval = window.setInterval(() => {
            // Don't poll if there's an active task being processed
            if (!TaskWithActionStore.taskWithAction) {
                TasksStore.hiddenLoadAssignedTasksList();
            }
        }, 10000);

        return () => {
            clearInterval(interval);
        };
    }, []);
};
